// src/components/NewsDetail.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import API from "../utils/api";
import { getLeagues } from "../services/leaguesService";

function NewsDetail() {
  const { id } = useParams();
  const [news, setNews] = useState(null);
  const [leagueName, setLeagueName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchNews() {
      try {
        const { data: newsData } = await API.get(`/api/news/${id}/`);
        setNews(newsData);

        const leagues = await getLeagues();
        const league = leagues.find(l => l.id === newsData.league);
        setLeagueName(league ? league.name : "بدون دسته‌بندی");
      } catch (err) {
        console.error(err);
        setError("خطا در بارگذاری خبر!");
      } finally {
        setLoading(false);
      }
    }
    fetchNews();
  }, [id]);

  if (loading) {
    return React.createElement("p", null, "در حال بارگذاری خبر...");
  }
  if (error) {
    return React.createElement("p", { className: "text-red-500" }, error);
  }
  if (!news) {
    return null;
  }

  // تبدیل هر پاراگراف به یک المان <p>
  const paragraphs = news.content
    .split("\n\n")
    .map((para, i) =>
      React.createElement("p", { key: i }, para)
    );

  return React.createElement(
    "article",
    { dir: "rtl", className: "max-w-3xl mx-auto p-4" },
    // عکس
    React.createElement("img", {
      src: news.image,
      alt: news.title,
      className: "w-full h-auto rounded mb-4 object-cover"
    }),
    // دسته بندی
    React.createElement(
      "h4",
      { className: "text-indigo-600 font-semibold mb-2 text-right" },
      leagueName
    ),
    // عنوان
    React.createElement(
      "h2",
      { className: "text-2xl font-bold mb-4 text-right" },
      news.title
    ),
    // متن کامل خبر
    React.createElement(
      "div",
      { className: "prose prose-rose max-w-none text-justify" },
      paragraphs
    )
  );
}

export default NewsDetail;
